import {
  IntegrationStatusResultV2IntegrationStatus,
  IntegrationStatusResultV2Success,
} from '@chilipiper/api-client-external-calendar'
import { IntegrationStatusResultV2 } from '@chilipiper/api-client-external-calendar/data-contracts'

export const getExternalCalendar = (
  integration?: IntegrationStatusResultV2 | null
): 'GoogleCalendar' | 'MicrosoftOutlook' | undefined => {
  if (integration?.type !== 'Success') {
    return
  }

  const { externalCalendar }: IntegrationStatusResultV2IntegrationStatus = integration.value

  return externalCalendar
}

export const getCalendarStatus = (
  integration?: IntegrationStatusResultV2 | null
): 'connected' | 'trouble' | 'disconnected' | 'notConnected' => {
  if (!integration) {
    return 'disconnected'
  }

  if (integration.type === 'Success') {
    const integrationStatus: IntegrationStatusResultV2IntegrationStatus = integration.value

    switch (integrationStatus.type) {
      case 'NeverConnectedAccount':
        return 'notConnected'

      case 'DisconnectedAccount':
        return 'disconnected'

      case 'InTrouble':
        return 'trouble'

      case 'ConnectedAccount':
        return 'connected'
      default:
        return 'disconnected'
    }
  }

  return 'disconnected'
}

export const getAccountId = (
  userCalendarIntegration: IntegrationStatusResultV2 | null | undefined
): string | undefined => {
  if (userCalendarIntegration?.type === 'Success') {
    const integrationStatus: IntegrationStatusResultV2IntegrationStatus =
      userCalendarIntegration.value
    return integrationStatus.accountId
  }
}

export const getEmail = (
  userCalendarIntegration: IntegrationStatusResultV2 | null | undefined
): string | undefined =>
  userCalendarIntegration?.type === 'Success'
    ? (userCalendarIntegration as IntegrationStatusResultV2Success).value.email
    : undefined
